<!-- 联系人列表 --->
<template>
  <div class="page_content">
    <div class="main">
      <div class="head">
        <!-- 搜索区域 -->
        <div class="searchArea">
          <div class="title">查询数据</div>
          <div class="content">
            <el-form style="width: 80%" label-width="70px">
              <el-row :gutter="24" >
                <el-col :span="12">
                  <el-form-item label="联系人：">
                      <el-select v-model="searchParams.username" placeholder="请选择" size="small" clearable>
                          <el-option v-for="item in allContact"
                          :key="item.id"
                          :label="item.username"
                          :value="item.username"></el-option>
                        </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="添加人：">
                      <el-select v-model="searchParams.creator_id" placeholder="请选择" size="small" clearable>
                          <el-option v-for="item in allCreator"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"></el-option>
                        </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div>
              <el-button size="small" icon="el-icon-search" type="primary" class="btnStyle" @click="onSearch">查 询</el-button>
              <el-button size="small" icon="el-icon-refresh-left" @click="onResetting">重 置</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="tableArea">
        <div class="tableHead">
          <div class="title">联系人列表</div>
          <div>
            <el-button type="primary" icon="el-icon-plus" size="small" class="btnStyle" @click="operation('add')">新 建</el-button>
            <el-button icon="el-icon-delete" size="small" @click="deletionByQuery">删 除</el-button>
          </div>
        </div>
        <!-- 表格区域 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{background:'#FAFAFA',color:'#405891'}" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                  {{scope.$index+1}}
              </template>
              </el-table-column>
              <el-table-column prop="username" label="联系人姓名" width="180" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="mobile" label="手机" width="120">
              </el-table-column>
              <el-table-column prop="email" label="邮箱" width="180">
              </el-table-column>
              <el-table-column prop="creator"  label="添加人" width="150">
              </el-table-column>
              <el-table-column prop="create_time" label="添加时间" width="180">
              </el-table-column>
              <el-table-column prop="beizhu" label="备注内容" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                  <el-button style="color:#437EDE" type="text" @click="operation('edit',scope.row)">编辑</el-button>
                  <el-button style="color:#437EDE" type="text" @click="handleDelete(scope.row)">删除</el-button>
              </template>
              </el-table-column>
          </el-table>
          <div style="margin-top:0.2rem;text-align:right">
              <a-pagination v-model="page" :pageSize="limit"  :page-size-options="pageSizeOptions" show-quick-jumper show-size-changer :total="totalCount" @change="onChange" @showSizeChange="pageSizeChange" />
          </div>
        </div>
      </div>
      <!-- 新增/编辑联系人弹框 -->
      <el-dialog :title="dialogTitle+'联系人'" :visible.sync="dialogVisiable" width="40%" @close="cancleAdd" :close-on-click-modal="false">
        <el-form label-width="120px" :model="addFormValue" :rules="rules"  ref="addFormValue">
          <el-form-item label="联系人名称：" prop="username">
            <el-input placeholder="请输入名称" size="small" v-model="addFormValue.username"></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="pushType">
                  <el-checkbox v-model="checkedMobile">手机</el-checkbox>
                  <el-checkbox v-model="checkedEmail">邮件</el-checkbox>
                  <span style="margin-left:40px;color:#93A6D2"><i class="el-icon-info"></i>最少选择一种联系方式</span>
          </el-form-item>
          <el-form-item label="手机号码：" prop="mobile" v-if="checkedMobile">
              <el-input placeholder="请输入" size="small" v-model="addFormValue.mobile" @input="handleChange($event,'mobile')"></el-input>
          </el-form-item>
          <el-form-item label="验证码：" prop="mobile_code" v-if="mobileCode">
              <el-input placeholder="请输入验证码" size="small" v-model="addFormValue.mobile_code">
                <span slot="suffix" v-if="countdownIng" style="font-size:0.14rem;color:#405891;cursor:pointer" @click="getCode('mobile')">获取验证码</span>
                <span slot="suffix" v-if="!countdownIng" style="font-size:0.14rem;color:#405891;font-weight:600;margin-right:20px">{{countdownTime}}<span style="margin-left:3px">s</span></span>
              </el-input>
          </el-form-item>
          <el-form-item label="邮箱号码："  prop="email" v-if="checkedEmail">
            <el-input placeholder="请输入" size="small" v-model="addFormValue.email"  @input="handleChange($event,'email')"></el-input>
          </el-form-item>
          <el-form-item label="验证码：" prop="email_code" v-if="emailCode">
              <el-input placeholder="请输入验证码" size="small" v-model="addFormValue.email_code">
                <span slot="suffix" v-if="countdownIng2" style="font-size:0.14rem;color:#405891;cursor:pointer" @click="getCode('email')">获取验证码</span>
                <span slot="suffix" v-if="!countdownIng2" style="font-size:0.14rem;color:#405891;font-weight:600;margin-right:20px">{{countdownTime2}}<span style="margin-left:3px">s</span></span>
              </el-input>
          </el-form-item>
          <el-form-item label="备注内容：" prop="beizhu">
              <el-input type="textarea" placeholder="请输入内容" size="small" v-model="addFormValue.beizhu"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancleAdd" size="small">取 消</el-button>
          <el-button type="primary" @click="saveNewContact()" size="small" class="btnStyle">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
const TIME_COUNT = 60 // 倒计时的时间
import { getContactList, addContact, getMobileCode, getEmailCode, editContact,getAllCreator,deleteContact } from '@/api/page/contactList.js';
export default {
  name: 'contactList',
  data() {
    return {
      // 搜索
      searchParams: {
         username: '', // 联系人
         creator_id: '', // 添加人
      },
      allContact: [], // 联系人列表
      allCreator: [], // 添加人列表
      tableData:[], // 表格数据
      selectedRows: [], //选中列表
      dialogVisiable: false, //新增or编辑联系人弹框
      dialogTitle: '新增',
      // 添加联系人
      addFormValue:{
        username: '',
        mobile: '',
        mobile_code: '',
        email: '',
        email_code: '',
        beizhu: '',
      },
      // 页面以及每页展示条数
      page:1,
      limit:10,
      totalCount: 500,
      pageSizeOptions: ['10','20','30','40','50'],
      // 验证规则
      rules: {
        username: [
          { required: true, message: '请输入联系人名称', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱号码', trigger: 'blur' }
        ],
        mobile_code: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' }
        ],
         email_code: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' }
        ],
      },
      checkedMobile: true, // 推送方式--手机
      checkedEmail: false, // 推送方式--邮件
      emailCode: false, // 邮箱验证码
      mobileCode: true, // 手机验证码
      countdownIng: true,
      countdownIng2: true,
      countdownTime: 0,
      countdownTime2:0,
      timer: null,
      timer2: null,
      editMobile: '',
      editEmail: '',
    };
  },
  mounted() {
    this.getAllContact()
    this.getAllCreator()
    this.getContactList()
  },
  methods:{
    // 获取添加人列表
    getAllCreator() {
      let self = this;
       let data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        ts: this.stringTime(new Date())
      };
      getAllCreator(data).then(res=> {
         self.allCreator = res.data
      })
    },
    // 获取联系人列表
    getContactList() {
      let data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        page: this.page,
        limit: this.limit,
        username: this.searchParams.username,
        creator_id: this.searchParams.creator_id,
        ts: this.stringTime(new Date())
      };
      getContactList(data).then(res=> {
        this.tableData = res.data
        this.totalCount = res.meta.total_count
      })
      .catch((err)=> {
        console.log('error',err)
      })
    },
    getAllContact() {
      let data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        ts: this.stringTime(new Date())
      };
      getContactList(data).then(res=> {
        this.allContact = res.data
      })
      .catch((err)=> {
        console.log('error',err)
      })
    },
    // 查询
    onSearch() {
      this.page = 1;
      this.limit = 10,
      this.getContactList();
    },
    // 重置
    onResetting() {
     this.searchParams = {
      username: '',
      creator: ''
     }
     this.getContactList()
    },
    // 获取手机验证码
    getCode(type) {
      let data = {
          account: window.localStorage.getItem('account'),
          token: window.localStorage.getItem('token'),
          ts: this.stringTime(new Date())
      }
      if(type == 'mobile') {
        if(this.isNull(this.addFormValue.mobile)) {
          this.$message({
            message:'请填写手机号码',
            type:'warning',
          })
        } else {
          data.mobile = this.addFormValue.mobile;
          getMobileCode(data).then(res=> {
            this.countdown(type)
          })
          .catch((err)=> {

          })
        }
      }
      if(type == 'email') {
        if(this.isNull(this.addFormValue.email)) {
          this.$message({
            message:'请填写邮箱',
            type:'warning',
          })
        } else {
          data.email = this.addFormValue.email;
          getEmailCode(data).then(res=> {
            this.countdown(type)
          })
          .catch((err)=> {
          })
        }
      }
    },
    // 验证码倒计时
    countdown(type) {
      if(type == 'mobile') {
        if(!this.timer) {
          this.countdownTime = TIME_COUNT
          this.countdownIng = false
          this.timer = setInterval(()=> {
            if(this.countdownTime > 0 && this.countdownTime <= TIME_COUNT){
              this.countdownTime --
            } else {
              this.countdownIng = true
              clearInterval(this.timer)
              this.timer = null
            }
          },500)
        }
      }
      if(type == 'email') {
        if(!this.timer2) {
          this.countdownTime2 = TIME_COUNT
          this.countdownIng2 = false
          this.timer = setInterval(()=> {
            if(this.countdownTime2 > 0 && this.countdownTime2 <= TIME_COUNT){
              this.countdownTime2 --
            } else {
              this.countdownIng2 = true
              clearInterval(this.timer2)
              this.timer2 = null
            }
          },500)
        }
      }
    },
    // 保存新增or编辑联系人信息
    saveNewContact() {
      let self = this;
      if(!this.checkedEmail&&!this.checkedMobile) {
        this.$message.warning('请至少选择一种联系方式')
        return
      }
      self.$refs.addFormValue.validate((valid) => {
        if (valid) {
        let data = {
          account: window.localStorage.getItem('account'),
          token: window.localStorage.getItem('token'),
          ts: this.stringTime(new Date())
        };
        let obj = Object.assign(data,self.addFormValue)
        if(this.dialogTitle == '新增') {
          addContact(data).then(res=> {
            if(res.data === 'success') {
              self.$message({
                message: '添加成功',
                type: 'success'
              })
              self.getContactList();
              self.$refs.addFormValue.resetFields()
              self.dialogVisiable = false
              self.countdownTime = 0
              self.countdownTime2 = 0
            } else {
              self.$message({
                message: res.meta.message,
                type: 'warning'
              })
            }
          })
        } else if( this.dialogTitle == '编辑') {
          editContact(data).then(res=> {
             if(res.data === 'success') {
              self.$message({
                message: '编辑成功',
                type: 'success'
              })
              self.getContactList();
              self.$refs.addFormValue.resetFields()
              self.dialogVisiable = false
              self.countdownTime = 0
              self.countdownTime2 = 0
              } else {
              self.$message({
                message: res.meta.message,
                type: 'warning'
              })
            }
          })
        }
        } else {
          return false;
        }
      })
    },
    cancleAdd() {
      this.dialogVisiable = false
      this.$refs.addFormValue.resetFields()
    },
    // 页面切换
    onChange(val) {
      this.page = val;
      this.getContactList();
    },
    pageSizeChange(page,pageSize) {
      this.limit = pageSize
      this.getContactList()
    },
    // 新建or编辑联系人
    operation(type,val) {
      this.dialogVisiable = true;
      this.addFormValue = {};
      if(type == 'edit') {
        this.dialogTitle = '编辑';
        this.$nextTick(()=> {
          this.addFormValue = Object.assign({},val)
          this.checkedMobile = !this.isNull(val.mobile)? true:false
          this.checkedEmail = !this.isNull(val.email)? true:false
          this.mobileCode = false
          this.emailCode = false
          this.editMobile = val.mobile
          this.editEmail = val.email
        })
      } else {
        this.dialogTitle = '新增'
      }
    },

    // 编辑信息时候若手机和邮箱变动才会展示对呀的验证码输入框
    handleChange(e,type) {
      if(type == 'mobile') {
        this.mobileCode = (e!== this.editMobile? true:false)
      } else if (type == 'email') {
        this.emailCode = (e !==this.editEmail? true:false)
      }
    },
    // 删除
    handleDelete(item) {
      let self = this;
      this.$confirm(`确定要删除${item.username}吗？`,'提示',{
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
      }).then(()=> {
         this.onDelete(item.id)
      }).catch(()=> {

      })
    },
    // 选中数据
    handleSelectionChange(val) {
      this.selectedRows = [];
      this.selectedRows = val;
    },
    // 批量删除
    deletionByQuery () {
      if(this.isNull(this.selectedRows)) {
        this.$message.warning('请选择需要删除的联系人')
        return
      }
      let arr = [];
      let ids = [];
      this.selectedRows.forEach(item=> {
        arr.push(item.username)
        ids.push(item.id)
      })
      this.$confirm(`确定要删除${arr.join(',')}吗？`,'提示',{
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
      }).then(()=> {
        ids.forEach(j=> {
          this.onDelete(j)
        })
      }).catch(()=> {

      })
    },
    onDelete(id) {
      let data = {
          account: window.localStorage.getItem('account'),
          token: window.localStorage.getItem('token'),
          cid: id,
          ts: this.stringTime(new Date())
      }
      deleteContact(data).then(res=> {
        if(res.data == 'success') {
          this.$message({
            message:'删除成功',
            type: 'success'
          })
          this.getContactList()
        } else {
          this.$message({
            message:'删除失败，请重试',
            type: 'warning'
          })
        }
      })
    }
  },
  watch:{
    checkedMobile(val) {
      if(this.dialogTitle == '新增') {
        this.mobileCode = val? true:false
      } else {
        if(!val) {
          this.mobileCode = false
          this.addFormValue.mobile = ""
          this.addFormValue.mobile_code=""
        }
      }
    },
    checkedEmail(val) {
       if(this.dialogTitle == '新增') {
         this.emailCode = val? true:false
      } else {
        if(!val) {
          this.emailCode = false
          this.addFormValue.email = ""
          this.addFormValue.email_code = ""
        }
      }
    },
  }
};
</script>
<style lang="less" scoped>
.content ::v-deep .el-select {
    width: 100%;
}
.content ::v-deep .el-form-item {
  margin-bottom: 0;
  .el-form-item__label {
      color: #405891;
  }
  }
</style>